import axios from "axios"

// get the question listing based on the survey uuid
export function getRespondentQuestionList({ uuid }) {
  return new Promise(( resolve, reject ) => {
    axios.get(`/consumer/admin/api/v1/survey-respondent/${uuid}/questions`)
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}